import React from "react";
import { Route, Navigate } from "react-router-dom";
import { useData } from "../components/context"; // Import your context hook

const PrivateRoute = ({ Component, ...rest }) => {
  //   const { accessToken } = useData();
  const accessToken = localStorage.getItem("accessToken");
  const isAuthenticated = !!accessToken;
  console.log(accessToken);
  console.log(isAuthenticated);

  return isAuthenticated ? (
    <Component {...rest} />
  ) : (
    <Navigate to="/" replace />
  );
};

export default PrivateRoute;
